import React from "react";
import Foerderrechner from "../../Foerderrechner";
import Mitglieder from "../sections/Mitglieder";
import Pelletheizung3DIframe from "../../Pelletsheizung3D";

const navigationConfig = [
  {
    title: "Verband",
    items: [
      {
        label: "Über den DEPV",
        link: "ueber-den-depv",
        uuid: "093e3e56-1529-41f6-a115-231570e683db",
      },
      {
        label: "Verbandsstruktur",
        link: "verbandsstruktur",
        uuid: "83817bc5-2b71-42bc-9ad1-556653d81faa",
      },
      {
        label: "DEPV-Fachgruppen",
        link: "depv-fachgruppen",
        uuid: "ef6244e8-e16d-4c4d-a5db-1820017b4398",
        items: [
          {
            label: "Feuerungstechnik",
            link: "depv-fachgruppen/feuerungstechnik",
            internal: true,
            hideInNav: true,
            uuid: "defc1142-15eb-4099-bad3-43ff6ec392ad",
          },
          {
            label: "Pelletproduktion und Qualitätssicherung",
            link: "depv-fachgruppen/pelletproduktion-und-qualitaetssicherung",
            hideInNav: true,
            internal: true,
            uuid: "18437019-3d61-4282-b7b5-b1f8714f0859",
          },
          {
            label: "Lagerung und Handel",
            link: "depv-fachgruppen/lagerung-und-handel",
            internal: true,
            hideInNav: true,
            uuid: "4bf36250-5c40-4b42-9ea6-bfb867bcc17a",
          },
          {
            label: "Holzbriketts",
            link: "depv-fachgruppen/holzbriketts",
            internal: true,
            hideInNav: true,
            uuid: "6bb78440-b0bc-4c2a-b627-f622813fe2e7",
          },
          {
            label: "Hackschnitzel",
            link: "depv-fachgruppen/hackschnitzel",
            internal: true,
            hideInNav: true,
            uuid: "3b7cd001-5bb0-482b-8f7f-4dbc3fb4e39a",
          },
          {
            label: "Marketingbeirat",
            link: "depv-fachgruppen/marketingbeirat",
            internal: true,
            hideInNav: true,
            uuid: "133cedb9-6693-476c-8091-0d2a8a20c8d4",
          },
        ],
      },
      {
        label: "Pelletheizung 3D",
        link: "pelletheizung-3d",
        uuid: "e0b0d7de-1dcb-40fa-bc8b-a69eb6d5eafe",
        hideInNav: true,
        children: [<Pelletheizung3DIframe key="pelletheizung-3d" />],
      },
      {
        label: "Verbandsinterna",
        link: "verbandsinterna",
        internal: true,
      },
      {
        label: "Ansprechpartner",
        link: "ansprechpartner",
        uuid: "014b860b-bd40-45e6-98d0-7003aa8516a4",
        internal: true,
      },
      {
        label: "Mitglieder",
        link: "mitglieder",
        uuid: "eca4a197-a6c3-4aa7-99e8-368fb5ed4537",
        children: [<Mitglieder key="mitglieder" />],
      },
      {
        label: "Rabatte für Mitglieder",
        link: "mitglieder-rabatte",
        uuid: "8ddfb5d0-1b56-4b25-bbcf-e8f8329a77d4",
        internal: true,
      },
      {
        label: "Mitglied werden",
        link: "mitglied-werden",
        uuid: "ba85da3c-1869-42fc-9f39-6f1e07d6d24a",
      },
      {
        label: "Termine",
        link: "termine",
      },
      {
        label: "Stellenmarkt",
        link: "stellenmarkt",
        uuid: "2e09fd23-cc35-4e1e-9fff-74b829e593fd",
      },
      {
        label: "Vorstandssitzungen",
        link: "vorstandssitzungen",
        internal: true,
      },
      {
        label: "Mitgliederversammlungen",
        link: "mitgliederversammlungen",
        internal: true,
        // uuid: '7bfae3d6-4f57-4063-a7b6-ced57e7ccf51',
      },
    ],
  },
  {
    title: "Marktdaten",
    items: [
      {
        label: "Pelletpreis",
        link: "pelletpreis",
        uuid: "30b557ad-9a08-42d3-9937-a89fe942569f",
      },
      {
        label: "Pelletfeuerungen",
        link: "pelletfeuerungen",
        uuid: "4543fe34-3b75-4267-9032-4c98a8abe55c",
      },
      {
        label: "Pelletproduktion",
        link: "pelletproduktion",
        uuid: "210e0725-70da-43b2-8152-efb76fffd8c9",
      },
      // {
      //   label: 'International',
      //   link: 'international',
      //   uuid: '473e65f7-da67-46cd-827b-c6b7da2cac36',
      // },
      {
        label: "Marktdaten intern",
        link: "marktdaten-intern",
        uuid: "93ae3a8b-3903-4c17-b6a7-5df0645dc20c",
        internal: true,
      },
    ],
  },
  {
    title: "Technik und Recht",
    items: [
      {
        label: "Emissionen",
        link: "emissionen",
        uuid: "6363a632-05eb-4340-b97c-c22699657281",
        items: [
          {
            label: "1. BlmSchV",
            link: "emission/1-bimschv",
            uuid: "deca8829-28a7-4fa0-be48-0e1bc363ef02",
          },
          {
            label: "TA Luft",
            link: "emission/ta-luft",
            uuid: "c5c7b2b0-9c1e-4d23-8024-6b2ab624a5bd",
          },
          {
            label: "Ökodesign",
            link: "oekodesign",
            uuid: "588edb86-5e20-40d3-b62b-9b34572acfcd",
            internal: true,
          },
        ],
      },
      {
        label: "Effizienz",
        link: "effizienz",
        uuid: "cb3f65b9-b313-465f-a841-b1b6a15d3952",
        items: [
          {
            label: "Gebäudeenergiegesetz (GEG)",
            link: "effizienz/gebaeudeenergiegesetz-geg",
            uuid: "4e8ca6d9-26a0-4690-bf34-b3f1ee0b53b1",
          },
          {
            label: "Altanlagenlabel",
            link: "effizienz/altanlagenlabel",
            uuid: "615f8a75-adff-445f-8f6a-b5d7b7e34a0c",
          },
          {
            label: "Energielabel",
            link: "effizienz/energielabel",
            uuid: "94481340-cb5d-42da-b725-e318243b8dab",
          },
          {
            label: "EWärmeG in Baden-Württemberg",
            link: "effizienz/ewaermeg-in-baden-wuerttemberg",
            uuid: "dacc1fc4-57f9-4c93-9508-73b73814940d",
          },
        ],
      },
      {
        label: "Kennwerte",
        link: "kennwerte",
        uuid: "9d454dc6-6d08-4acd-accc-c09b87cb363c",
      },
      {
        label: "Förderprogramme",
        link: "foerderprogramme",
        uuid: "4b974e13-0d7a-429b-a71b-6de200b56de3",
        children: [<Foerderrechner key="rechner" />],
      },
      {
        label: "Lagerung",
        link: "lagerung",
        uuid: "7fe3ec71-c0f4-407f-8e07-1d6abec44619",
      },
      {
        label: "Heizungsbetrieb",
        link: "heizungsbetrieb",
        uuid: "5343f553-2daa-46fe-b8e6-188c631c780b",
      },
      {
        label: "Fachinformationen",
        link: "fachinformationen",
        internal: true,
      },
    ],
  },
  {
    title: "Moderne Holzbrennstoffe",
    items: [
      {
        label: "Brennstoff Holzpellets",
        link: "brennstoff-holzpellets",
        uuid: "8316ece9-916d-4d3c-a1a7-1c38795c106b",
      },
      {
        label: "Brennstoff Holzbriketts",
        link: "brennstoff-holzbriketts",
        uuid: "72bd58b5-45fa-45d1-9595-64a21016b193",
      },
      {
        label: "Brennstoff Holzhackschnitzel",
        link: "brennstoff-holzhackschnitzel",
        uuid: "7518df6f-7ad6-4346-b37e-8080580faeb6",
      },
      {
        label: 'Studie "Klimaholz"',
        link: "studie-klima-holz",
        uuid: "9b07395c-7f2c-47c6-89eb-b4fc7687bf1a",
      },
    ],
  },
  {
    title: "Presse und Mediathek",
    items: [
      {
        label: "DEPV-Freitagspost!",
        link: "depv-freitagspost",
        internal: true,
      },
      {
        label: "News und Pressemitteilungen",
        link: "news-und-pressemitteilungen",
      },
      {
        label: "Interviews und Stellungnahmen",
        link: "interviews-stellungnahmen",
      },
      {
        label: "Politik / interne Stellungnahmen",
        link: "politik-interne-stellungnahmen",
        internal: true,
      },
      {
        label: "Presseveranstaltungen",
        link: "presseveranstaltungen",
      },
      {
        label: "Pressebilder",
        link: "pressebilder",
      },
      {
        label: "Mediathek",
        link: "mediathek",
      },
      {
        label: "Marketingmaterial / Vorlagen",
        link: "marketingmaterial-vorlagen",
        internal: true,
        uuid: "ced53c0f-8ed5-43e3-85b2-b5643503416c",
      },
    ],
  },
  {
    title: "Kontakt",
    mobileTile: "Kontakt und Impressum",
    items: [
      // static
      {
        label: "Kontakt",
        link: "kontakt",
      },
      {
        label: "Impressum",
        link: "impressum",
        uuid: "f3367146-2044-47a6-97db-cca4c42cde74",
      },
      {
        label: "Datenschutz",
        link: "datenschutz",
        uuid: "f1998d28-53db-4c20-b6b3-345618b188ad",
      },
    ],
  },
];

export default navigationConfig;
